"use client"
import Form from "react-bootstrap/Form";
import React, {useEffect, useState} from "react";
import {MdExpandLess} from '@react-icons/all-files/md/MdExpandLess'
import {MdExpandMore} from '@react-icons/all-files/md/MdExpandMore'
import {useAxios} from "hooks/useAxios";
import {useTekstClient} from "hooks/useTekstClient";
import useGebruiker from "hooks/useGebruiker";
import useSWR from "swr";
import {useSearchParams} from 'next/navigation'
import {useSetSearchParams} from "hooks/useSetSearchParams";



const useFetchTypen= () => {
    const {get} = useAxios();
    return useSWR(['/wiki/typen'], () =>
            get('/wiki/typen', {})
                .then(res => res.data)
                .catch(error => {
                    if (error.response.status !== 409) throw error;
                }), {
            refreshInterval: 0,
            revalidateIfStale: false,
            revalidateOnReconnect: true,
            revalidateOnFocus: false,
        }
    );
};

const FilterType = () => {
    const [expand, setExpand] = useState(true);
    const [toonMeer, setToonMeer] = useState(true);
    const {tekst, isLoadingTekst} = useTekstClient();
    const {ingelogdeGebruiker} = useGebruiker()
    const {deleteParamArrayInt, addParamArrayInt} = useSetSearchParams();
    const searchParams = useSearchParams();
    const isReleaseNotes = searchParams.get('inhoud') === 'release'
    const paramTypes = searchParams.get('typen') ? searchParams.get("typen")?.split(',').map(x => parseInt(x)) : []



    const { data: typenData, error: typenError, isLoading: typenIsLoading } = useFetchTypen();


    const handleOnChange = (e, id) => {
        const {checked} = e.target
        if (checked)
            addParamArrayInt('typen', id, null)
        else
            deleteParamArrayInt('typen', id, null)

    }


    return <>
        {!isReleaseNotes && typenData?.length > 0 && <div>
            <b className={`flex items-center cursor-pointer`} onClick={() => setExpand(!expand)}>
                {expand
                    ? <MdExpandLess/>
                    : <MdExpandMore/>
                }
                {tekst('pagina:support:kenniscentrum:type:titel')}
            </b>
            {expand &&
                <div className={'ml-3'}>

                    {typenData.filter(x => x.id !== 3).map((type, k) => {
                        return <div key={`typebox-${type.id}`}>
                            {(k < 4 || toonMeer)
                                && <><Form.Check
                                    key={`check-${type.id}`}
                                    id={`filter-type-${type.id}`}
                                >
                                    <Form.Check.Input type={'checkbox'}
                                                      onChange={e => handleOnChange(e, type.id)}
                                                      checked={paramTypes.includes(type.id)}/>
                                    <Form.Check.Label className={`flex items-center`}>
                                        {tekst(`pagina:support:kenniscentrum:type:${type.naam}`)}
                                        <small
                                            className={`ml-auto text-kleur-licht-grijs-blauw`}>{type.wiki_item_gepubliceerd_count}</small>
                                    </Form.Check.Label>
                                </Form.Check>

                                </>
                            }
                        </div>
                    })}

                    {typenData?.length > 4
                        ? toonMeer
                            ? <div onClick={() => {
                                setToonMeer(false)
                            }} className={`flex items-center cursor-pointer`}>
                                {tekst('algemeen:searchbar:Minder')} <MdExpandLess/>
                            </div>
                            : <div onClick={() => {
                                setToonMeer(true)
                            }} className={`flex items-center cursor-pointer`}>
                                {tekst('algemeen:searchbar:Meer')} <MdExpandMore/>
                            </div>
                        : <></>
                    }

                </div>
            }
            <div className={`border-b border-kleur-licht-grijs-blauw pb-[20px] mb-[20px]`}/>
        </div>}
    </>

}
export default FilterType;